import Joi from 'joi';

/**
 * Generic schema to validate that the new status is not the same as the current status,
 * that the current status is not null, and that the current status is part of the fixed statuses.
 * If newStatus is the same as currentStatus, it should return an error.
 * If the current status is not part of fixedStatuses, it should return an error for transient status.
 * @param newStatus - The new status to validate against.
 * @param fixedStatuses - An array of valid statuses.
 * @returns - The Joi schema for validation.
 */
export const setStatusSchema = (newStatus: string, fixedStatuses: string[]) => {
	return Joi.object({
		status: Joi.string()
			.required()
			.custom((value, helpers) => {
				// Check if the current status is the same as the newStatus
				if (value === newStatus) {
					return helpers.error('any.invalid', { value });
				}
				// Check if the current status is in fixedStatuses
				if (!fixedStatuses.includes(value)) {
					return helpers.error('any.only', { value });
				}
				// Return the value if valid
				return value;
			})
			.messages({
				'any.invalid': `validations|set-status|status-is-already-${newStatus.toLowerCase()}`,
				'any.only': 'validations|set-status|cannot-change-transient-status',
				'any.required': 'validations|set-status|required',
			})
			.allow(null)
			.messages({
				'any.only': 'validations|set-status|cannot-change-transient-status',
			}),
	}).unknown(true);
};
